import React, {useEffect, useState} from 'react';
import {Link, useOutletContext, useParams, useSearchParams} from 'react-router-dom';
import TitleMain from "../../../components/Title/TitleMain";
import {useModal} from "../../../contexts/ModalContext";
import {useUser} from "../../../contexts/UserContext";
import AxiosConfig from "../../../services/AxiosConfig";
import {useBreadcrumb} from "../../../contexts/BreadcrumbContext";
import {generateBreadcrumbSegmentsAdmin} from "../../../services/BreadcrumbService";
import ActiviteCreation from "../../../components/Admin/Activtes/ActiviteCreation";
import ActivitesVue from "../../../components/Admin/Activtes/ActivitesVue";
import ActiviteVue from "../../../components/Admin/Activtes/ActiviteVue";
import ActiviteModification from "../../../components/Admin/Activtes/ActiviteModification";

function AdminActivitePage() {
    const {user} = useUser();
    const [searchParams] = useSearchParams();
    const mode = searchParams.get('mode') || 'consultation';

    return (
        <div className="content">
            {mode === 'creation' ?
                <ActiviteModification /> :
                mode === 'modification' ?
                    <ActiviteModification /> :
                    <ActiviteVue />
            }
        </div>
    )
}

export default AdminActivitePage;
